import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React, { useState } from 'react';
import styled from 'styled-components';
import { useFieldValidation } from '../../hooks/validation-field';
import { FieldContainer, Field, Label, FieldBefore, FieldAfter } from '../field';
import { Helper } from '../Helper';
import { Icon } from '../icon';
import { makeInputText, makeCustomSup } from './mixins';
var InputText = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeInputText(props);
});
var CustomSup = styled.sup(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeCustomSup();
});
var TooglePassword = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  border: 0;\n  outline: 0;\n  background: none;\n  box-shadow: none;\n"])));
var patterns = {
  number: '[0-9]*',
  email: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$',
  url: 'https?://.+'
};
export var Input = function Input(_ref) {
  var value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '...' : _ref$placeholder,
      name = _ref.name,
      id = _ref.id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      readonly = _ref.readonly,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      onKeyPress = _ref.onKeyPress,
      rules = _ref.rules,
      errors = _ref.errors,
      fieldOptions = _ref.fieldOptions,
      noBottomMargin = _ref.noBottomMargin;

  var _useFieldValidation = useFieldValidation(rules, errors, name, disabled),
      fieldStates = _useFieldValidation.fieldStates,
      classes = _useFieldValidation.classes,
      setValue = _useFieldValidation.setValue,
      setActive = _useFieldValidation.setActive;

  var _useState = useState(type),
      _useState2 = _slicedToArray(_useState, 2),
      fieldType = _useState2[0],
      setFieldType = _useState2[1];

  var iconSize = {
    small: 'small',
    size18: '18',
    size22: '22'
  };
  var iconColor = {
    black16: 'rgba(0, 0, 24, 0.16)',
    black: '#231F20'
  };
  var iconName = {
    password: 'password',
    eyeOpen: 'eye-open',
    eyesOff: 'eye-off'
  };

  var handleIconSize = function handleIconSize() {
    return (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.size) === iconSize.small ? iconSize.size18 : iconSize.size22;
  };

  var handleIconColor = function handleIconColor() {
    return disabled ? iconColor.black16 : iconColor.black;
  };

  var handleIconName = function handleIconName() {
    return "icon-light-".concat(fieldType === iconName.password ? iconName.eyesOff : iconName.eyeOpen);
  };

  var handleOnChange = function handleOnChange(event, callback) {
    var value = event.target.value;
    setValue(value);
    callback && callback(event);
  };

  var handleOnBlur = function handleOnBlur(event, callback) {
    setActive(false);
    callback && callback(event);
  };

  var handleOnFocus = function handleOnFocus(event, callback) {
    setActive(true);
    callback && callback(event);
  };

  var togglePassword = function togglePassword() {
    setFieldType(type === "password" && fieldType === type ? "text" : type);
  };

  return React.createElement(FieldContainer, null, fieldOptions && fieldOptions.label && React.createElement(Label, {
    htmlFor: id || "input-".concat(name)
  }, fieldOptions.label, rules && rules.required && React.createElement(CustomSup, null, "*")), React.createElement(Field, Object.assign({}, fieldOptions, {
    states: Object.assign({}, fieldStates),
    className: classes
  }), fieldOptions && fieldOptions.before && React.createElement(FieldBefore, Object.assign({}, fieldOptions, {
    className: "field-before"
  }), fieldOptions.before), React.createElement(InputText, Object.assign({
    name: name,
    id: id || "input-".concat(name),
    placeholder: placeholder,
    type: fieldType,
    inputmode: type === 'number' ? 'numeric' : type
  }, patterns[type] && {
    pattern: patterns[type] || ''
  }, {
    disabled: disabled,
    readonly: readonly,
    value: value,
    autoCorrect: "off",
    autoCapitalize: "off",
    autoComplete: "off",
    spellcheck: "false",
    onChange: function onChange(event) {
      return handleOnChange(event, _onChange);
    },
    onFocus: function onFocus(event) {
      return handleOnFocus(event, _onFocus);
    },
    onBlur: function onBlur(event) {
      return handleOnBlur(event, _onBlur);
    }
  }, onKeyPress ? {
    onKeyPress: onKeyPress
  } : {}, {
    ref: rules
  }, fieldOptions, fieldStates)), (fieldOptions && Boolean(fieldOptions.after) || type === 'password') && React.createElement(FieldAfter, Object.assign({}, fieldOptions, {
    className: "field-after"
  }), type === 'password' ? React.createElement(TooglePassword, {
    type: "button",
    onClick: function onClick() {
      return !disabled && togglePassword();
    }
  }, React.createElement(Icon, {
    size: handleIconSize(),
    color: handleIconColor(),
    name: handleIconName()
  })) : fieldOptions && fieldOptions.after)), React.createElement(Helper, {
    name: name,
    fieldOptions: fieldOptions,
    errors: errors,
    noBottomMargin: noBottomMargin
  }));
};